import { ToastrService } from "ngx-toastr";
import { DmsService } from "./dms.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DmsFilters, FILTER_SP_Type } from "../Models/SharePointPracticeModel";
import { FeatureFlags } from "../shared/app.constant";
import { HttpResponse } from "@angular/common/http";

export class dmsUtility {
  eventListeners: Array<() => void> = [];
  IsViewDocuments: boolean;
  IsAddDocuments: boolean = false;
  IsManageDocuments: boolean = false;
  IsDeleteDocuments: boolean = false;
  IsManageFolders: boolean = false;
  IsSync: boolean = false;

  defaultClientStatus: string = "Active";
  menuName_OpenInBrowser: string = "Open in browser";
  menuName_OpenInDesktop: string = "Open in desktop app";
  menuName_Preview: string = "Preview";
  menuName_EditProperties: string = "Edit properties";
  menuName_CopyTo: string = "Copy to";
  menuName_MoveTo: string = "Move to";
  menuName_Activity: string = "Activity";
  menuName_VersionHistory: string = "Version history";
  menuName_Download: string = "Download";
  menuName_Delete: string = "Delete";
  menuName_OpenFileLocation: string = "Open file location";
  menuName_Sync_to_OneDrive: string = "Sync to OneDrive";
  menuName_Remove_from_OneDrive: string = "Remove from OneDrive";

  documentFilter = [
    { id: 1, name: DmsFilters.Client, icon: '../../../assets/img/client_icon.svg', type: FILTER_SP_Type.Client, KCType:FILTER_SP_Type.KCScreen },
    { id: 2, name: DmsFilters.ClientGroups, icon: '../../../assets/img/client_group_icon.svg', type: FILTER_SP_Type.Client },
    { id: 3, name: DmsFilters.Document, icon: '../../../assets/img/document_icon.svg', type: FILTER_SP_Type.Common , KCType:FILTER_SP_Type.KCScreen},
    { id: 4, name: DmsFilters.Folder, icon: '../../../assets/img/folder_icon.svg', type: FILTER_SP_Type.Item , KCType:FILTER_SP_Type.KCScreen},
  ];

  showRequestFilesFeatureFlag: boolean = false;
  showSyncToOneDrive: boolean = false;

  featureMap = [
      { flag: FeatureFlags.ShowRequestFiles, prop: 'showRequestFilesFeatureFlag' },
      { flag: FeatureFlags.ShowSyncToOneDrive, prop: 'showSyncToOneDrive' }
    ];

  constructor(public _dmsService: DmsService, public toastr: ToastrService) {

  }

  protected addEventListener(
    target: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    target.addEventListener(type, listener, options);
    this.eventListeners.push(() => target.removeEventListener(type, listener, options));
  }

  protected cleanupEventListeners(): void {
    this.eventListeners.forEach(remove => remove());
    this.eventListeners = [];
  }

  isValidDate(date: string): boolean {
    return !!date && !date.includes('0001');
  }

  getUserPermission(siteId: number) {
    this._dmsService.GetUserPermission(siteId).subscribe((res: any) => {
      if (res.statusCode == 200) {
        const userPermissions = JSON.parse(res.httpResponse);
        if (userPermissions.length > 0) {
          const userPermission = userPermissions[0];
          this.IsViewDocuments = userPermission.IsViewDocuments;
          this.IsAddDocuments = userPermission.IsAddDocuments;
          this.IsManageDocuments = userPermission.IsManageDocuments;
          this.IsDeleteDocuments = userPermission.IsDeleteDocuments;
          this.IsManageFolders = userPermission.IsManageFolders;
          this.IsSync = userPermission.IsSync;
        } else {
          this.toastr.warning('No user permissions found.');
        }
      }
      if (res.statusCode == 204) {
        this.toastr.warning(res.message);
      }
    });
  }

  noPermissionMSG() {
    this.toastr.warning("You do not have permission.", "User Permission");
  }

  noNavigationMSG() {
    this.toastr.warning("Folder not yet synced with sharepoint site.", "Sharepoint");
  }

  getUserPermissionV2(siteId: number): Observable<boolean> {
    return this._dmsService.GetUserPermission(siteId).pipe(
      map((res: any) => {
        if (res.statusCode == 200) {
          const userPermissions = JSON.parse(res.httpResponse);
          if (userPermissions.length > 0) {
            const userPermission = userPermissions[0];
            this.IsViewDocuments = userPermission.IsViewDocuments;
            this.IsAddDocuments = userPermission.IsAddDocuments;
            this.IsManageDocuments = userPermission.IsManageDocuments;
            this.IsDeleteDocuments = userPermission.IsDeleteDocuments;
            this.IsManageFolders = userPermission.IsManageFolders;
            this.IsSync = userPermission.IsSync;

            return this.IsViewDocuments;
          } else {
            this.toastr.warning('No user permissions found.');
            return false;
          }
        } else if (res.statusCode == 204) {
          this.toastr.warning(res.message);
          return false;
        }
        return false;
      })
    );
  }

  buildBreadcrumbInfo(folderId: string, breadcrumbData: any[]): { breadcrumb: string, rootFolderName: string, clientName: string } {
    const folderMap = new Map<string, any>();
    breadcrumbData.forEach(folder => folderMap.set(folder.Id, folder));

    const segments: string[] = [];
    let rootFolderName = '';
    let clientName = '';

    // Traverse up from current folder
    let current = folderMap.get(folderId);
    while (current) {
      segments.unshift(current.FolderName);

      const parent = folderMap.get(current.ParentId);

      // If the parent is client-level (i.e., root node), set client name
      if (parent && parent.ParentId === "00000000-0000-0000-0000-000000000000") {
        rootFolderName = current.FolderName;
        clientName = parent.FolderName;
        break;
      }

      // If the current folder is directly under the root
      if (current.ParentId === "00000000-0000-0000-0000-000000000000") {
        clientName = current.FolderName;
        break;
      }

      current = parent;
    }

    const breadcrumb = segments.join(' / ');

    return { breadcrumb, rootFolderName, clientName };
  }

  getSelectedFilterFromFileType(filetype: string | null | undefined): string | null {
    if (!filetype) return null;

    const types = filetype
      .split(',')
      .map(t => t.trim().toLowerCase());

    return types.includes('folder')
      ? DmsFilters.Document
      : DmsFilters.Document;
  }

  loadFeatureFlags(): void {
    this.featureMap.forEach(f => {
      this._dmsService.isFeatureEnabled(f.flag).then(val => {
        (this as any)[f.prop] = val;
      });
    });
  }

  // FINAL DOWNLOAD HANDLER
  triggerDownload(response: HttpResponse<Blob>) {

        if (!response?.body) return;

        let fileName = 'DMS_Documents.zip';

        const contentDisposition =
        response.headers.get('content-disposition');

        if (contentDisposition) {
        const match = /filename="?(.+?)"?$/i.exec(contentDisposition);
        if (match?.[1]) fileName = match[1];
        }

        const blob = response.body;
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
  }

}